export const BACKEND_URL =
  (import.meta as any).env.VITE_BACKEND_URL ||
  "https://meryl-filmy-luba.ngrok-free.dev";

// REST base (backend is expected to serve APIs under /api)
export const API_BASE_URL = `${BACKEND_URL}/api`;

export const ENDPOINTS = {
  AUTH: {
    REGISTER: "/auth/register",
    LOGIN: "/auth/login",
    ME: "/auth/me",
    GOOGLE: "/auth/google",
    FORGOT_PASSWORD: "/auth/forgot-password",
    VERIFY_EMAIL: "/auth/verify-email",
    SEND_VERIFICATION: "/auth/send-verification",
    RESET_PASSWORD: "/auth/reset-password",
    RESEND_VERIFICATION: "/auth/resend-verification",
    REFRESH_TOKEN: "/auth/refresh-token",
  },
  SESSIONS: {
    CREATE: "/sessions",
    HISTORY: "/sessions/history",
    ASSIGN_LISTENER: (id: string) => `/sessions/${id}/assign-listener`,
    DECLINE: (id: string) => `/sessions/${id}/decline`,
    UPDATE_STATUS: (id: string) => `/sessions/${id}/status`,
    GET: (id: string) => `/sessions/${id}`,
    MESSAGES: (id: string) => `/sessions/${id}/messages`,
    // UPCOMING: "/sessions/upcoming", // API not in use
  },
  RTC: {
    CONFIG: "/rtc/config",
    AGORA_TOKEN: "/rtc/agora-token",
  },
  USERS: {
    LISTENERS: "/users/listeners",
    LISTENER: (id: string) => `/users/listeners/${id}`,
    PROFILE: "/users/profile",
    SUBSCRIBE_PUSH: "/users/subscribe",
    WITHDRAW: "/users/withdraw",
    WITHDRAWALS: "/users/withdrawals",
  },
  CONTACT: "/contact",
  ADMIN: {
    CONTACTS: "/admin/contacts",
    CONTACT_ID: (id: string) => `/admin/contacts/${id}`,
    SEND_EMAIL: "/admin/send-email",
    EMAIL_HISTORY: "/admin/email-history",
  },
} as const;
